export default __webpack_public_path__ + "static/media/drag.821a5180.svg";